// extracted by mini-css-extract-plugin
module.exports = {"contentMain":"institution__contentMain___1bKy-","main":"institution__main___3sXeb","fixedQrcode":"institution__fixedQrcode___1JB-5"};